import { CHANGE_LOCALE } from './constants.setting.store';

export default {
  changeLocale({ commit }, locale) {
    commit(CHANGE_LOCALE, locale);
  },
};
